module.exports = __webpack_public_path__ + "img/hr portal.ded01b38.png";